export const lootConfig = {
    ITEM_CONTAINER_COLLIDER_RADIUS: 30,

    DEBUG: {
        OVERRIDE_ITEMS_ROLLED_QUANTITY: 0,
        DRAW_ITEM_CONTAINER_COLLIDER: false,
        CHESTS_DROP_A_TON_OF_ITEMS: false
    }
};
